import React, { useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { I18n } from 'aws-amplify';
import Button from '../Button';
import styles from './styles.module.css';

const Dialog = ({
  open,
  onClose,
  title,
  subtitle,
  content,
  type = 'info',
  cancelText = I18n.get('Cancel'),
  onCancel = onClose,
  acceptText = I18n.get('OK'),
  onAccept = onClose,
}) => {
  const ref = useRef();

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (ref.current === event.target) {
        onClose();
      }
    };

    if (open) {
      ref.current.showModal();
      document.addEventListener('mousedown', handleOutsideClick);
    } else {
      ref.current.close();
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [open, onClose]);

  return createPortal(
    <dialog ref={ref} className={styles.dialog}>
      <button className={styles.closeButton} onClick={onClose}>
        &times;
      </button>
      {title && <h2 className={styles.title}>{title}</h2>}
      {subtitle && <h3 className={styles.subtitle}>{subtitle}</h3>}
      <div className={styles.content}>{content}</div>
      <div className={styles.actions}>
        {type === 'confirm' && (
          <Button color='blueGray' text={cancelText} onClick={onCancel} size='small' />
        )}
        {(type === 'confirm' || type === 'alert') && (
          <Button text={acceptText} onClick={onAccept} size='small' />
        )}
      </div>
    </dialog>,
    document.body
  );
};

export default Dialog;
